
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ember-apollo-3-mutations-creating-links.json") })
        }
      }, "path---ember-apollo-3-mutations-creating-links");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---ember-apollo-3-mutations-creating-links!./.cache/json/ember-apollo-3-mutations-creating-links.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---ember-apollo-3-mutations-creating-links!./.cache/json/ember-apollo-3-mutations-creating-links.json
// module chunks = 154